import { axiosHelper } from 'Services/AxiosHelper';
import { deleteRegisteredDefaultCardTransactionBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnDeleteRegisteredCard';
const deleteRegisteredCardTransaction = async (params: deleteRegisteredDefaultCardTransactionBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default deleteRegisteredCardTransaction;
